/**
 * Auth Query Keys
 *
 * TanStack Query v5 query key factory for auth-related queries.
 * Follows the factory pattern for type-safe, hierarchical cache keys.
 *
 * @module features/auth/hooks/queryKeys
 */

export const authKeys = {
  // All auth-related queries
  all: () => ['auth'] as const,

  // Passkey queries
  passkeys: {
    all: () => [...authKeys.all(), 'passkeys'] as const,
    list: () => [...authKeys.passkeys.all(), 'list'] as const,
    detail: (passkeyId: string) =>
      [...authKeys.passkeys.all(), 'detail', passkeyId] as const,
  },

  // User profile (for cache invalidation after auth)
  profile: () => [...authKeys.all(), 'profile'] as const,

  // Email verification status
  emailVerification: () => [...authKeys.all(), 'emailVerification'] as const,
} as const;
